export default __webpack_public_path__ + "static/media/ecearina2.1ad2bbe8.jpg";